import { graphql } from "../generated";

export const MUTATE_REPORT_POST = graphql(`
  mutation MutateReportPost($id: Int!, $reason: String!) {
    reportPost(id: $id, reason: $reason)
  }
`);
